export default __webpack_public_path__ + "static/media/aurora.79786caf.svg";